// extracted by mini-css-extract-plugin
export default {"title":"Focus_title__yzis2","container":"Focus_container__+fPKz","cardTitle":"Focus_cardTitle__CWeyM","cardText":"Focus_cardText__TrE6D","formControl":"Focus_formControl__se5mT"};